import { AMPLITUDE_OPERATION_METHODS, API_ENV_KEYS } from '@sweetspot/shared/util/constants'
import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'

const { REACT_APP_API_ENV } = process.env as unknown as {
  REACT_APP_API_ENV: string
}

const SAMPLE_RATE_PRODUCTION = 0.7 // Covers 70% of users sessions
const SAMPLE_RATE_DEV = 0 // Covers 0% of users sessions

let isSessionReplayActive = false

export const sessionReplayTracking = sessionReplayPlugin({
  forceSessionTracking: false,
  shouldInlineStylesheet: true,
  sampleRate: REACT_APP_API_ENV === API_ENV_KEYS.PROD ? SAMPLE_RATE_PRODUCTION : SAMPLE_RATE_DEV,
})

export const startAmplitudeSessionTracking = async (): Promise<void> => {
  if (isSessionReplayActive) return

  try {
    await amplitude.add(sessionReplayTracking).promise
    isSessionReplayActive = true
  } catch (error) {
    console.error('Failed to start session replay tracking:', error)
  }
}

export const endAmplitudeSessionTracking = async (): Promise<void> => {
  if (!isSessionReplayActive) return

  try {
    await amplitude.remove(sessionReplayTracking?.name).promise
    isSessionReplayActive = false
  } catch (error) {
    console.error('Failed to end session replay tracking:', error)
  }
}

export const setAmplitudeUserId = (userId: string) => {
  amplitude.setUserId(userId)
}

export const updateUserProperty = (
  userProperty: string,
  userValue: string | string[],
  operation = AMPLITUDE_OPERATION_METHODS.SET
) => {
  const identifyEvent = new amplitude.Identify()

  if (operation === AMPLITUDE_OPERATION_METHODS.POST_INSERT) {
    identifyEvent.postInsert(userProperty, userValue)
  } else {
    identifyEvent.set(userProperty, userValue)
  }

  amplitude.identify(identifyEvent)
}
